import React from 'react';
import { bool, func, object, shape } from 'prop-types';
import { connect } from 'react-redux';
import { Table } from '@devexpress/dx-react-grid-material-ui';

import { selectInventory } from '../../actions/inventoryActions';
import { setDevice } from '../../actions/deviceActions';
import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import InventoryTableRowMenu from './InventoryTableRowMenu';

const InventoryTableActionCell = ({
    companyInfo,
    isFullHubAllowed,
    selectInventory,
    setDevice,
    row,
    ...props
}) => {
    if (row.isLeaf) {
        return <Table.Cell {...props} />;
    }
    return (
        <Table.Cell>
            <InventoryTableRowMenu
                companyInfo={companyInfo}
                hidden={!isFullHubAllowed}
                item={row}
                selectInventory={selectInventory}
                setDevice={setDevice}
            />
        </Table.Cell>
    );
};

InventoryTableActionCell.defaultProps = {
    isFullHubAllowed: false,
    selectInventory:  () => {}
};

InventoryTableActionCell.propTypes = {
    companyInfo:      object,
    isFullHubAllowed: bool,
    row:              shape({
        showMenu: bool
    }),
    selectInventory: func
};

export const mapStateToProps = ({
    companyInfo,
    core: { currentScopes }
}) => ({
    companyInfo,
    isFullHubAllowed: isAllowed(currentScopes, Permissions('iothubFull'))
});

const mapDispatchToProps = {
    selectInventory,
    setDevice
};

export default connect(mapStateToProps, mapDispatchToProps)(InventoryTableActionCell);
